import React from "react";
// import { useSelector, useDispatch } from "react-redux";
// import { Header, Sidebar } from "../Layout";
import {
    Radar, RadarChart, PolarGrid,
    PolarRadiusAxis, ResponsiveContainer
} from 'recharts';

const FeedbackSnapshot = () => {
    const data = [
        { name: 'A', x: 60, y: 100 },
        { name: 'B', x: 80, y: 60 },
        { name: 'C', x: 85, y: 60 },
        { name: 'D', x: 80, y: 60 },
        { name: 'E', x: 80, y: 60 },
    ];
    const customTick = ({ payload, x, y, textAnchor, stroke, radius }) => {
        return (
            <g
                className="recharts-layer recharts-polar-angle-axis-tick"
            >
                <text
                    radius={radius}
                    stroke={stroke}
                    x={x}
                    y={y}
                    textAnchor="middle"
                    className="recharts-text recharts-polar-angle-axis-tick-value"
                    fontSize={15}
                >

                    <tspan x={x} dy="0em" color="red"
                        fontWeight={600} 
                    >
                        {payload.value}
                    </tspan>
                </text>

            </g>
        );
    }

    return (<>
        <div className="row clearfix">
            <div className="col-lg-12 col-md-12 col-sm-12">
                <div className="card card-radius">
                    <div className="header card-header custum-bg-warning rounded">
                        <h2 className="text-white">Feedback Snapshot</h2>
                    </div>
                    <div className="body card-body-shadow">
                        <div className="row">
                            <div className="col-lg-12 col-md-6 col-sm-12 text-center">
                                <ResponsiveContainer width="100%" height={600}>
                                    <RadarChart height={650} width={500}
                                        outerRadius="80%" data={data}>
                                        <PolarGrid strokeWidth={3} stroke="black" gridType="polygon" />
                                        {/* <PolarAngleAxis dataKey='name' /> */}
                                        <PolarRadiusAxis angle={90} tick={customTick} tickCount={5} />
                                        <Radar name="Mike" dataKey="x" strokeWidth={3} stroke="#fed7b8" fill="#fed7b8" fillOpacity={0.6} />
                                        <Radar name="Lily" dataKey="y" strokeWidth={3} stroke="#b698c8" fill="#b698c8" fillOpacity={0.6} />
                                    </RadarChart>
                                </ResponsiveContainer>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>)
}

export default FeedbackSnapshot;